import { render, staticRenderFns } from "./EmployeeAnnounce.vue?vue&type=template&id=53c616a6&scoped=true&"
import script from "./EmployeeAnnounce.vue?vue&type=script&lang=js&"
export * from "./EmployeeAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAnnounce.vue?vue&type=style&index=0&id=53c616a6&prod&lang=css&"
import style1 from "./EmployeeAnnounce.vue?vue&type=style&index=1&id=53c616a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c616a6",
  null
  
)

export default component.exports